<script lang="ts">
    import queryString from "query-string";
    import { navigate } from "svelte-navigator";
    import { appManager } from "../../AppManagerStore";
    import { Col, Container, Row } from "sveltestrap";
    import { _ } from "svelte-i18n";
    import AngleStart from "../../svg/shapes/AngleStart.svelte";

    let accepted: boolean = false;

    let acceptInvite = async () => {
        accepted = false;

        const parsed = queryString.parse(window.location.search);

        // confirm email, this also logs in the user.
        if (parsed.token) {
            accepted = await $appManager.IdentityApi.acceptInvite({
                accessToken: await $appManager.Authenticator.getAccessToken(),
                id: atob(parsed.token as string),
            });
        }

        if (accepted) {
            setTimeout(() => {
                navigate(`${$appManager.PublicUrl}app`, { replace: true });
            }, 6000);
        }
    };
    
</script>

{#await acceptInvite()}
    <div />
{/await}


<section>
    <Container class="d-flex flex-column">
        <Row class="align-items-center justify-content-center gx-0 min-vh-100">
            <Col>
                {#if !accepted}
                    <h1 class="display-3 fw-bold">{$_("user.acceptinvite.error.title")}</h1>

                    <p class="mb-5 text-muted">
                        {$_("user.acceptinvite.error.subtitle")}
                    </p>

                    <p class="mb-6 text-muted">
                        {$_("user.acceptinvite.error.subsubtitle")}
                    </p>
                {:else}
                    <h1 class="mb-0 fw-bold">{$_("user.acceptinvite.ok.thanks")} 👍</h1>

                    <p class="mb-6 text-muted">
                        {$_("user.acceptinvite.ok.subtitle")}
                    </p>

                    <p class="mb-6 text-muted">
                        {$_("user.emailconfirm.ok.redirect.part1")}
                        <a href={$appManager.PublicUrl}
                            >{$_("user.emailconfirm.ok.redirect.here")}</a>
                        {$_("user.emailconfirm.ok.redirect.part2")}
                    </p>
                {/if}
            </Col>

            <div
                class="col-lg-7 offset-lg-1 align-self-stretch d-none d-lg-block">
                <div
                    class="h-100 w-cover bg-cover"
                    style="background-image: url(/img/covers/cover-belgium-at-night.jpg);" />

                <div class="shape shape-start shape-fluid-y text-white">
                    <AngleStart />
                </div>
            </div>
        </Row>
    </Container>
</section>
